// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberV3ClientGeneratedContactInformationPurposeType } from './prescriberV3ClientGeneratedContactInformationPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PrescriberV3ClientGeneratedEmailAddressUpsearchModel {
    'emailAddressId'?: number | null;
    'emailAddressType'?: PrescriberV3ClientGeneratedContactInformationPurposeType;
    'address': string;
    'language': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PrescriberV3ClientGeneratedEmailAddressUpsearchModel>> = [
        {
            "name":     "emailAddressId",
            "baseName": "emailAddressId",
            "type":     "number"
        },
        {
            "name":     "emailAddressType",
            "baseName": "emailAddressType",
            "type":     "PrescriberV3ClientGeneratedContactInformationPurposeType"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriberV3ClientGeneratedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
